import { getServerUrl } from '../config';

/**
 * Servicio para verificar si un usuario es tipo dispositivo compartido
 */
export class DeviceUserService {
  private static instance: DeviceUserService;
  private serverUrl: string;

  private constructor() {
    this.serverUrl = getServerUrl();
  }

  public static getInstance(): DeviceUserService {
    if (!DeviceUserService.instance) {
      DeviceUserService.instance = new DeviceUserService();
    }
    return DeviceUserService.instance;
  }

  /**
   * Verifica si el usuario es tipo dispositivo compartido
   */
  public async isDeviceUser(email: string): Promise<{ isDevice: boolean }> {
    try {
      if (!email || !email.trim()) {
        return { isDevice: false };
      }
      
      const url = `${this.serverUrl}/api/device/check`;
      console.log('[DeviceUserService] Verificando usuario dispositivo:', email, 'URL:', url);
      
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email: email.toLowerCase().trim() }),
      });
      
      console.log('[DeviceUserService] Respuesta status:', response.status, response.ok);
      
      if (response.ok) {
        const data = await response.json();
        return {
          isDevice: data.isDevice === true
        };
      } else {
        await response.text();
        console.error('[DeviceUserService] Error en respuesta:', response.status);
      }
      return { isDevice: false };
    } catch (error) {
      console.error('[DeviceUserService] Error checking device user:', error);
      return { isDevice: false };
    }
  }
}

export default DeviceUserService;

